export default "Escape Skagen opened in July 2019.";